export enum MUTATION_KEYS {
  CREATE_DOCUMENT_PAGE = 'create_document_page',
  UPDATE_DOCUMENT_PAGE = 'update_document_page',
  DELETE_DOCUMENT_PAGE = 'delete_document_page',
  REORDER_DOCUMENT_PAGES = 'redorder_document_pages',
}

export default MUTATION_KEYS
